module.exports = __webpack_public_path__ + "static/media/Frame-9.2ce78c36.svg";